import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsApi } from '@/lib/api';

export function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        // Track page view on route change
        analyticsApi.track('page_view', location.pathname);
    }, [location]);

    return null;
}
